import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { ProductLineDeleteCard } from './components/ProductLineDeleteCard';
import { ProductLineDetailsCard } from './components/ProductLineDetailsCard';
import { ProductsCard } from './components/ProductsCard';

export function ProductLineDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const productLineQueryResults = useQuery({
        queryKey: ['productLine', id],
        queryFn: () => Api.Products.ProductLines.getProductLine(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={productLineQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <ProductLineDetailsCard productLine={data} />
                            <ProductsCard
                                productLine={data}
                                refetch={productLineQueryResults.refetch}
                            />

                            {!data.products.length && (
                                <Can I="delete" a="Product">
                                    <ProductLineDeleteCard productLine={data} />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
